import { render, staticRenderFns } from "./FormAddReviewBoard.vue?vue&type=template&id=327df6e4&scoped=true&"
import script from "./FormAddReviewBoard.vue?vue&type=script&lang=js&"
export * from "./FormAddReviewBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327df6e4",
  null
  
)

export default component.exports